import { isAuthenticated } from '../guards/auth';

export default [
  {
    path: '/objednavky',
    name: 'orders',
    meta: { moduleId: 'orders' },
    component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/List.vue'),
    beforeEnter: isAuthenticated,
  },
  {
    path: '/objednavky/detail/:id',
    name: 'orders.detail',
    meta: { moduleId: 'orders', scanButtonShift: true },
    component: () => import(/* webpackChunkName: "orders" */ '@/views/orders/Detail.vue'),
    beforeEnter: isAuthenticated,
  },
];
